import React from 'react';
import { Hero } from './components/Hero';
import { StatsAndProof, ExtendedTestimonials } from './components/ProofSections';
import { PainPoints } from './components/PainPoints';
import { ProductOffer } from './components/ProductOffer';
import { Pricing } from './components/Pricing';
import { CostSection, FooterAndProofPopup, GuaranteeAndFaq } from './components/ClosingSections';
import { MetaPixel } from './components/MetaPixel';
export function App() {
  return <main className="min-h-screen w-full overflow-x-hidden bg-brand-ink text-white" data-id="element-0" data-mp="2rikmb2g0a59y">
      <MetaPixel data-id="element-1" data-mp="2mjpvbd7vxaer" />
      <Hero data-id="element-2" data-mp="31aqdwb2cikom" />
      <StatsAndProof data-id="element-3" data-mp="31agp2qt1ejki" />
      <PainPoints data-id="element-4" data-mp="31bs2licab5ot" />
      <ProductOffer data-id="element-5" data-mp="31c9uy3vtszrg" />
      <Pricing showAnchor data-id="element-6" data-mp="31ctfztgrw49p" />
      <ExtendedTestimonials data-id="element-7" data-mp="2wka1mua9h53u" />
      <GuaranteeAndFaq data-id="element-8" data-mp="2wiywaq163pam" />
      <CostSection data-id="element-9" data-mp="2wip6b2g4hi4x" />
      <Pricing data-id="element-10" data-mp="2wi5nzkmk8rqd" />
      <FooterAndProofPopup data-id="element-11" data-mp="28u5y0mx2p5cu" />
    </main>;
}